export const SPIN_EVENT = 'betohalics:spin-result';

export function announceSpin(bet, win) {
    try { window.dispatchEvent(new CustomEvent(SPIN_EVENT, { detail: { bet, win } })); } catch { /* ignore */ }
}
